import { listByCode } from "@/api/zl/clinical-rule";
export default {
  props: {
    code: String,
    projects: {
      type: Array,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      rules: [],
    };
  },
  created() {
    this.loadRules();
  },
  methods: {
    loadRules() {
      this.loading = true;
      listByCode(this.code)
        .then((res) => {
          let data = res.data.data;
          if (this.loaded) {
            this.loaded(data);
          }
          this.rules = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
